module.exports = __webpack_public_path__ + "img/needle-left2.3a75b598.png";